export default function AboutMe() {
  return (
    <section className="about-me section-container">
      <h2>About me</h2>
      <p>
        {" "}
        I'm a Machine Learning and UI/UX Engineer based in the vibrant
        city of Mountain View, California. I specialize in crafting
        user-friendly and visually appealing user experiences that bring ideas
        to life. I'm now focused on leveraging machine learning to develop
        innovative solutions and improve user experiences of engineers. I also
        love playing video games, watching movies, and film-making.
      </p>
    </section>
  );
}
